export default {
  faqPage: (state) => {
    return state.faqPage;
  },
  faq: (state) => {
    return state.faq;
  },
};
